/* eslint-disable prettier/prettier */
import { CSS_UNITS } from "./ui_utils.js";
import { TW_DATA_TAG } from "./util.js";

class PdfPrintService {
  constructor(app) {
    this.printProgress = null;
    this.printProgressCurrentPage = null;
    this.printProgressTotalPages = null;
    this.printArea = null;
    this.printProgressCancelBtn = null;
    this.printArea = null;
    this.currentPrintPage = 0;
    this.printWin = null;
    this._app = app;
  }

  updatePrintProgress(current, total, me) {
    if (me.printingCanceled || current === total) {
      me.printProgress.style.display = "none";
    }
    me.printProgressCurrentPage.textContent = current;
    me.printProgressTotalPages.textContent = total;
  }

  renderPrintPages() {
    const me = this;
    const doc = me.printWin.document;
    const totalPages = me._app.pdfDocument.pages.length;
    me.currentPrintPage = 0;
    me.printWin.document.title = me._app.pdfDocument.documentName;
    doc.body.style.margin = "0";
    doc.body.style.padding = "0";
    doc.body.style.backgroundColor = "#F0F0F0";
    const css = doc.createElement("style");
    css.innerHTML += "@page {margin: 0;}";
    css.innerHTML += "@supports ((size:A4) and (size:1pt 1pt)) {";
    css.innerHTML += "@page { size: ";
    // eslint-disable-next-line no-unsanitized/property
    css.innerHTML += me._app.pdfDocument.pages[0].originalWidth / CSS_UNITS;
    css.innerHTML += "pt ";
    // eslint-disable-next-line no-unsanitized/property
    css.innerHTML += me._app.pdfDocument.pages[0].originalHeight / CSS_UNITS;
    css.innerHTML += "pt; } }";

    css.innerHTML += ".tw2018css_dialog {";
    css.innerHTML += "border-spacing: 4px;";
    css.innerHTML += "color: #fff;";
    css.innerHTML += "font: 14px Arial;";
    css.innerHTML += "background-color: #474747;";
    css.innerHTML += "border: 1px solid hsla(0,0%,0%,.5);";
    css.innerHTML += "border-radius: 4px;";
    css.innerHTML += "box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);";
    css.innerHTML += "padding: 15px 15px 10px 15px;";
    css.innerHTML += "width: 256px";
    css.innerHTML += "}";

    css.innerHTML += "#tw2018elem_overlayContainer {";
    css.innerHTML += "display: table;";
    css.innerHTML += "position: absolute;";
    css.innerHTML += "top: 0;";
    css.innerHTML += "left:0;";
    css.innerHTML += "width: 100%;";
    css.innerHTML += "height: 100%;";
    css.innerHTML += "background-color: hsla(0,0%,0%,.2);";
    css.innerHTML += "z-index: 40000;";
    css.innerHTML += "}";

    css.innerHTML += "#tw2018elem_overlayContainer.tw2018css_hidden {";
    css.innerHTML += "display: none !important;";
    css.innerHTML += "}";

    css.innerHTML += "#tw2018elem_overlayContainer > .tw2018css_container {";
    css.innerHTML += "display: table-cell;";
    css.innerHTML += "vertical-align: middle;";
    css.innerHTML += "text-align: center;";
    css.innerHTML += "}";

    css.innerHTML += "#tw2018elem_overlayContainer > * {";
    css.innerHTML += "overflow: auto;";
    css.innerHTML += "-webkit-overflow-scrolling: touch;";
    css.innerHTML += "}";

    css.innerHTML +=
      "#tw2018elem_overlayContainer > .tw2018css_container > .tw2018css_dialog {";
    css.innerHTML += "display: inline-block;";
    css.innerHTML += "padding: 15px 20px 10px 15px;";
    css.innerHTML += "line-height: 18px;";
    css.innerHTML += "width: 340px;";
    css.innerHTML += "}";

    css.innerHTML += "#tw2018elem_printProgress {";
    css.innerHTML += "width: 265px;";
    css.innerHTML += "margin: 0 auto;";
    css.innerHTML += "padding:15px;";
    css.innerHTML += "}";

    doc.head.appendChild(css);

    const overlayContainer = doc.createElement("div");
    overlayContainer.setAttribute("id", "tw2018elem_overlayContainer");
    overlayContainer.setAttribute(TW_DATA_TAG, "");

    me.printProgress = doc.createElement("div");
    me.printProgress.setAttribute(TW_DATA_TAG, "");
    me.printProgress.classList.add("tw2018css_dialog");
    // me.printProgress.style.backgroundColor = '#d6d6d6';
    // me.printProgress.style.margin = '0 auto';
    // me.printProgress.style.borderSpacing = '4px';
    // me.printProgress.style.position = 'fixed';
    // me.printProgress.style.top = (screen.availHeight / 2 - 95) + 'px';
    // me.printProgress.style.left = ((screen.availWidth - 300) / 2) + 'px';
    // me.printProgress.style.border = '1px solid hsla(0,0,0,.5)';
    // me.printProgress.style.borderRadius = '4px';
    // me.printProgress.style.boxShadow = '0 1px 4px rgba(0,0,0,0.3)';

    me.printProgress.setAttribute("id", "tw2018elem_printProgress");

    const printProgressOverlay = doc.createElement("div");
    printProgressOverlay.classList.add("tw2018css_container");
    printProgressOverlay.setAttribute(TW_DATA_TAG, "");
    printProgressOverlay.appendChild(me.printProgress);
    overlayContainer.appendChild(printProgressOverlay);

    me.printArea = doc.createElement("div");

    const span = doc.createElement("span");
    span.textContent = me._app.texts.preparing_for_print;
    me.printProgress.appendChild(span);

    me.printProgressCurrentPage = doc.createElement("span");
    me.printProgressCurrentPage.textContent = "1";
    me.printProgress.appendChild(me.printProgressCurrentPage);

    const span1 = doc.createElement("span");
    span1.textContent = "/";
    me.printProgress.appendChild(span1);

    me.printProgressTotalPages = doc.createElement("span");
    me.printProgressTotalPages.textContent = "1";
    me.printProgress.appendChild(me.printProgressTotalPages);

    const div = doc.createElement("div");
    div.classList.add("tw2018css_printProgressBtns");
    div.setAttribute(TW_DATA_TAG, "");
    div.style.verticalAlign = "middle";
    div.style.textAlign = "center";

    me.printProgressCancelBtn = doc.createElement("input");
    me.printProgressCancelBtn.type = "button";
    me.printProgressCancelBtn.value = me._app.texts.print_cancel_button;
    me.printProgressCancelBtn.style.width = "60px";
    me.printProgressCancelBtn.style.fontSize = "14px";
    me.printProgressCancelBtn.style.marginTop = "10px";

    me.printProgressCancelBtn.addEventListener("click", function () {
      me.printingCanceled = true;
      me.printProgress.style.display = "none";
    });

    div.appendChild(me.printProgressCancelBtn);

    me.printProgress.appendChild(div);
    doc.body.appendChild(me.printArea);

    doc.body.appendChild(overlayContainer);

    const renderNextPage = (resolve, reject) => {
      if (me.currentPrintPage >= totalPages || me.printingCanceled) {
        me.updatePrintProgress(me.currentPrintPage, totalPages, me);
        if (!me.printingCanceled) {
          doc.body.removeChild(overlayContainer);
          for (let j = 0; j < me.printArea.children.length; j++) {
            me.printArea.children[j].style.display = "block";
          }
        }
        resolve();
        return;
      }

      me.updatePrintProgress(me.currentPrintPage, totalPages, me);
      me.renderPrintPage(++me.currentPrintPage, me)
        .then(me.usePageForPrinting.bind(me))
        // })
        .then(function () {
          renderNextPage(resolve, reject);
        }, reject);
    };

    return new Promise(renderNextPage);
  }

  usePageForPrinting(size) {
    const img = this.printWin.document.createElement("img");
    img.src = this._app.elements.tw2018elem_printCanvas.toDataURL();
    img.style.width = size.width;
    img.style.height = size.height;
    img.style.display = "block";
    img.style.display = this.currentPrintPage === 1 ? "block" : "none";
    img.style.margin = "0 auto";
    img.style.pageBreakAfter = "always";
    img.style.pageBreakInside = "avoid";
    this.printArea.appendChild(img);
  }

  // Renders the page to the canvas of the given print service, and returns
  // the suggested dimensions of the output page.
  renderPrintPage(pageNumber, me) {
    const scratchCanvas = me._app.elements.tw2018elem_printCanvas;
    const page = me._app.pdfDocument.pages[pageNumber - 1];
    // The size of the canvas in pixels for printing.
    const PRINT_RESOLUTION = 150;
    const PRINT_UNITS = PRINT_RESOLUTION / 72.0;
    const pageOriginalWidth = page.originalWidth / CSS_UNITS;
    const pageOriginalHeight = page.originalHeight / CSS_UNITS;
    scratchCanvas.width = Math.floor(pageOriginalWidth * PRINT_UNITS);
    scratchCanvas.height = Math.floor(pageOriginalHeight * PRINT_UNITS);

    // The physical size of the img as specified by the PDF document.
    const width = Math.floor(pageOriginalWidth * CSS_UNITS) + "px";
    const height = Math.floor(pageOriginalHeight * CSS_UNITS) + "px";

    const ctx = scratchCanvas.getContext("2d");
    ctx.save();
    ctx.fillStyle = "rgb(255, 255, 255)";
    ctx.fillRect(0, 0, scratchCanvas.width, scratchCanvas.height);
    ctx.restore();

    return me._app.viewer.pdfDoc
      .getPage(pageNumber)
      .then(function (pdfPage) {
        const renderContext = {
          canvasContext: ctx,
          transform: [PRINT_UNITS, 0, 0, PRINT_UNITS, 0, 0],
          viewport: pdfPage.getViewport({ scale: 1, rotation: 0 }),
          intent: "print",
        };

        return pdfPage.render(renderContext).promise;
      })
      .then(function () {
        me._app.dispatchTWEvent(
          "pageRenderedForPrint",
          { pageNum: pageNumber, doc: me._app.pdfDoc },
          me._app.viewerDiv
        );

        return {
          width,
          height,
        };
      });
  }
}

export { PdfPrintService };
